import { useState } from "react";
import {
  Button,
  Flex,
  FormLabel,
  Input,
  Text,
  FormControl,
  FormErrorMessage,
  Alert,
  AlertIcon,
  AlertTitle,
  InputGroup,
  InputRightElement,
  IconButton,
  Box,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { changePasswordSchema } from "../../utils/formValidationSchema"; // You'll need to create this schema
import { useDispatch } from "react-redux";
import { BiShow, BiHide } from "react-icons/bi";
import { changePassword } from "../../redux/slices/usersSlice";

const ChangePassword = () => {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const dispatch = useDispatch();

  const initialValues = {
    email: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  // useEffect(() => {
  //   // If user is not logged in, redirect to login
  //   if (!auth?.user) {
  //     return navigate("/");
  //   }
  // }, [auth?.user, navigate]);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    setError(null);
    setSuccess(null);

    const response = await dispatch(
      changePassword({
        email: values.email,
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      })
    );
  
    if (response?.payload?.data) {
      setIsLoading(false);
      const data = response.payload.data;
      if (data && typeof data === "boolean") {
        setSuccess(response.payload.successMessage);
      }
      if (data.responseDescription) {
        setError(data.responseDescription);
      }
    } else {
      setIsLoading(false);
      throw new Error(
        response?.data?.responseDescription || "Failed to change password"
      );
    }
  };

  return (
    <Box bg={"#FFFFFF"} py={"4px"} height={"100vh"}>
      <Flex
        justifyContent={"space-between"}
        alignItems={"center"}
        borderBottom={"1px solid #B4B1B1"}
        py={"20px"}
        px={"20px"}
      >
        {/* <GoArrowLeft style={{ width: '24px', height: '24px' }} /> */}

        <Text fontSize={"18px"} fontWeight={"400"}>
          Change Password
        </Text>
      </Flex>
      <Flex w="full" h="100vh" overflow={"hidden"}>
        <Flex h={"full"} w="70%">
          <Flex w={["90%", "80%", "90%", "80%"]}>
            <Flex
              direction={"column"}
              bg={"white"}
              width={"full"}
              px={"1.5rem"}
              py="2rem"
            >
              <Flex justify={"space-between"} direction={"column"} mb="1.5rem">
                <Text fontSize={"1.25rem"}>
                  Enter your current password and new password
                </Text>
              </Flex>

              {error && (
                <Alert status="error" className="mt-3" mb="1rem">
                  <AlertIcon />
                  <AlertTitle>{error}</AlertTitle>
                </Alert>
              )}

              {success && (
                <Alert status="success" className="mt-3" mb="1rem">
                  <AlertIcon />
                  <AlertTitle>{success}</AlertTitle>
                </Alert>
              )}

              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={changePasswordSchema}
                onSubmit={(values) => handleSubmit(values)}
              >
                {({ errors, touched, handleBlur, handleChange, values }) => (
                  <Form>
                    <FormControl mb={4} color="black">
                      <FormLabel>Email</FormLabel>
                      <Input
                        value={values.email}
                        bgColor={"#F3F3F3"}
                        borderRadius={0}
                        borderColor={"transparent"}
                        name="email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </FormControl>
                    <FormControl
                      isInvalid={errors.oldPassword && touched.oldPassword}
                      mb={4}
                      color="black"
                    >
                      <FormLabel>Old Password</FormLabel>
                      <InputGroup>
                        <Input
                          type={showOldPassword ? "text" : "password"}
                          placeholder="Enter old password"
                          bgColor={"#F3F3F3"}
                          borderRadius={0}
                          borderColor={"transparent"}
                          name="oldPassword"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.oldPassword}
                        />
                        <InputRightElement>
                          <IconButton
                            aria-label={
                              showOldPassword
                                ? "Hide password"
                                : "Show password"
                            }
                            icon={showOldPassword ? <BiHide /> : <BiShow />}
                            onClick={() => setShowOldPassword(!showOldPassword)}
                            variant="ghost"
                            size="sm"
                          />
                        </InputRightElement>
                      </InputGroup>
                      {touched.oldPassword && errors.oldPassword && (
                        <FormErrorMessage>
                          {errors.oldPassword}
                        </FormErrorMessage>
                      )}
                    </FormControl>
                    <FormControl
                      isInvalid={errors.newPassword && touched.newPassword}
                      mb={4}
                      color="black"
                    >
                      <FormLabel>New Password</FormLabel>
                      <InputGroup>
                        <Input
                          type={showNewPassword ? "text" : "password"}
                          placeholder="Enter new password"
                          bgColor={"#F3F3F3"}
                          borderRadius={0}
                          borderColor={"transparent"}
                          name="newPassword"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.newPassword}
                        />
                        <InputRightElement>
                          <IconButton
                            aria-label={
                              showNewPassword
                                ? "Hide password"
                                : "Show password"
                            }
                            icon={showNewPassword ? <BiHide /> : <BiShow />}
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            variant="ghost"
                            size="sm"
                          />
                        </InputRightElement>
                      </InputGroup>
                      {touched.newPassword && errors.newPassword && (
                        <FormErrorMessage>
                          {errors.newPassword}
                        </FormErrorMessage>
                      )}
                    </FormControl>

                    <Button
                      isLoading={isLoading}
                      color={"white"}
                      bgColor={"#23A455"}
                      borderRadius="8px"
                      mt={"2rem"}
                      mb="1rem"
                      w={"full"}
                      type="submit"
                      loadingText="Changing Password..."
                    >
                      Change Password
                    </Button>
                  </Form>
                )}
              </Formik>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ChangePassword;
